module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('nav', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "nav"
  }, [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('.home'),
      expression: "'.home'"
    }],
    staticClass: "nav-item homelink"
  }, [_c('icon', {
    attrs: {
      "name": "home",
      "scale": "2"
    }
  })], 1), _vm._v(" "), _c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('.about'),
      expression: "'.about'"
    }],
    staticClass: "nav-item aboutlink"
  }, [_c('icon', {
    staticClass: "is-hidden-desktop fa-2x",
    attrs: {
      "name": "address-card",
      "scale": "2"
    }
  }), _c('span', {
    staticClass: "is-hidden-touch"
  }, [_vm._v("About")])], 1), _vm._v(" "), _c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('.clients'),
      expression: "'.clients'"
    }],
    staticClass: "nav-item clientslink"
  }, [_c('icon', {
    staticClass: "fa fa-handshake-o is-hidden-desktop fa-2x",
    attrs: {
      "name": "handshake-o",
      "scale": "2"
    }
  }), _c('span', {
    staticClass: "is-hidden-touch"
  }, [_vm._v("Clients")])], 1), _vm._v(" "), _c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('.results'),
      expression: "'.results'"
    }],
    staticClass: "nav-item resultslink"
  }, [_c('icon', {
    staticClass: "fa fa-bar-chart is-hidden-desktop fa-2x",
    attrs: {
      "name": "bar-chart",
      "scale": "2"
    }
  }), _c('span', {
    staticClass: "is-hidden-touch"
  }, [_vm._v("Results")])], 1), _vm._v(" "), _c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('.gallery'),
      expression: "'.gallery'"
    }],
    staticClass: "nav-item gallerylink"
  }, [_c('icon', {
    staticClass: "fa fa-image is-hidden-desktop fa-2x",
    attrs: {
      "name": "image",
      "scale": "2"
    }
  }), _c('span', {
    staticClass: "is-hidden-touch"
  }, [_vm._v("Gallery")])], 1), _vm._v(" "), _c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('.contact'),
      expression: "'.contact'"
    }],
    staticClass: "nav-item contactlink"
  }, [_c('icon', {
    staticClass: "fa fa-envelope-open is-hidden-desktop fa-2x",
    attrs: {
      "name": "envelope-open",
      "scale": "2"
    }
  }), _c('span', {
    staticClass: "is-hidden-touch"
  }, [_vm._v("Contact")])], 1), _vm._v(" "), _c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('.home'),
      expression: "'.home'"
    }],
    staticClass: "nav-item is-hidden-touch"
  }, [_c('img', {
    staticClass: "is-pulled-right",
    attrs: {
      "src": require("./assets/visible_logo.png")
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "bmv-reflective"
  }, [_c('section', {
    staticClass: "hero bg-orange is-fullheight home"
  }, [_c('bubbles'), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('section', {
    staticClass: "hero bg-darkblue is-fullheight about"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('about')], 1)])]), _vm._v(" "), _c('section', {
    staticClass: "hero bg-clients clients"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "intro"
  }, [_vm._v("Just a Few of Our Clients & Partners")]), _vm._v(" "), _c('clientlist')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "results"
  }, [_c('section', {
    staticClass: "hero bg-lightblue is-fullheight"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "intro"
  }, [_vm._v("Our Results Speak For Themselves")]), _vm._v(" "), _c('bmv-bar-chart', {
    attrs: {
      "client": "Analytics8",
      "finder": "chart--A8",
      "chartdata": [89.62108731, 82.04283361, 93.73970346, 100, 139.3739703, 128.0889621, 138.9621087, 141.6803954, 155.601318, 142.9983526, 183.1960461, 197.9406919, 197.1169687, 161.4497529, 192.9159802, 213.0971993, 237.4794069],
      "initialmonth": 3,
      "monthlabel": "Month",
      "left": "1"
    }
  }, [_c('p', [_vm._v("Redeveloped Analytics8.com to be more accessible to search engine crawlers")]), _vm._v(" "), _c('p', [_vm._v("Immediate improvement of 39% in the first month")]), _vm._v(" "), _c('p', [_vm._v("More than doubled traffic within one year")])]), _vm._v(" "), _c('bmv-bar-chart', {
    attrs: {
      "client": "Vi",
      "finder": "chart--Vi",
      "chartdata": [100, 140.2236679, 133.4917038, 170.0899057, 168.7888312, 187.8517652, 224.4645859, 213.2811929, 209.9481032, 245.9980996, 210.715591, 214.845406, 231.9859659, 262.8170455, 225.166289, 221.8697464, 207.3020978, 255.7853958, 218.5512755, 265.9235436],
      "initialmonth": 0,
      "monthlabel": "Quarter",
      "left": "0"
    }
  }, [_c('p', [_vm._v("Optimized ViLiving.com")]), _vm._v(" "), _c('p', [_vm._v("Immediate improvement of 40% in the first month")]), _vm._v(" "), _c('p', [_vm._v("More than doubled traffic within 6 quarters")])]), _vm._v(" "), _c('bmv-bar-chart', {
    attrs: {
      "client": "Corporate Suites Network",
      "finder": "chart--CSN",
      "chartdata": [100, 169.0023753, 167.3396675, 220.4275534, 226.128266, 242.8741093, 242.1615202, 234.0855107, 215.9144893, 209.7387173, 216.7458432, 187.1733967, 151.9002375, 225.5344418, 224.584323, 282.304038, 321.2589074, 345.1306413, 334.6793349],
      "initialmonth": -1,
      "monthlabel": "Month",
      "left": "0"
    }
  }, [_c('p', [_vm._v("Developed and optimized HabitatCSN.com")]), _vm._v(" "), _c('p', [_vm._v("Managed SEO aspects of branding transition to CSNHousing.com")]), _vm._v(" "), _c('p', [_vm._v("Dramatically increased traffic year over year")])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "gallery"
  }, [_c('section', {
    staticClass: "hero bg-orange is-fullheight"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "intro"
  }, [_vm._v("We Make Cool Sites, See?")]), _vm._v(" "), _c('gallery')], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "contact"
  }, [_c('section', {
    staticClass: "hero bg-map is-fullheight"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "intro"
  }, [_vm._v("Based In Chicago, Serving Clients Nationwide")]), _vm._v(" "), _c('contact')], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "bmv-reflection-container bottom"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-body has-text-centered"
  }, [_c('img', {
    staticClass: "main-logo",
    attrs: {
      "src": "static/visible_logo.png",
      "alt": "Visible"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "headline subtitle"
  }, [_vm._v("We make businesses more visible on the web.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flag"
  }, [_c('h1', [_vm._v("About Visible")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flag"
  }, [_c('h1', [_vm._v("Visible Clients")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flag"
  }, [_c('h1', [_vm._v("Visible Results")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flag"
  }, [_c('h1', {
    staticClass: "right"
  }, [_vm._v("Visible Gallery")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flag"
  }, [_c('h1', [_vm._v("Contact Visible")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-97a0c212!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 114
// module chunks = 2